<template>
<div>
    <!-- Section Element -->

    <div v-if="element.type =='Section'" class="section-bar" :class="{selected:element.key == selectedSectionKey}">
        <!-- <div class="section-indicator" :class="{selected:element.key == selectedSectionKey}"></div> -->
        {{element.title}}
        <span v-if="element.status" style="font-size:0.7em">({{element.status}})</span>
        <div style="width:30px;float:right;margin-top:-2px">
            <v-icon class="section-star" :class="{complete: element.complete}" @click="toggleSectionComplete">star_rate</v-icon>
        </div>
    </div>

    <!-- Divider -->

    <hr v-if="element.type =='Divider'" style="border:solid 0.5px #cccccc;margin -10px 0"/>

    <!-- Text -->

    <template v-if="element.type == 'Text'">
        <v-textarea v-if="element.multiLine"  :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
        @change="saveValue(element)"/>

        <v-text-field v-else :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
        @change="saveValue(element)"/>
    </template>

    <!-- Percent -->

    <v-text-field v-if="element.type =='Percent'" suffix="%"  :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
        @change="saveValue(element)"/>

    <!-- Rating -->
    <template v-if="element.type =='Rating'">
        <div style="margin-top:2px;font-size:12px;color:#888">{{element.title}}</div>
        <div @click="saveValue(element)">
        <v-rating color="yellow darken-2" background-color="grey lighten-2" xfull-icon="favorite" xempty-icon="favorite_border" :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
            style="margin-left:-9px;margin-top:-7px"/>
        </div>
    </template>

    <!-- Slider -->

    <div v-if="element.type =='Slider'">
        <div v-if="!element.compact" class="grey--text text--darken-2 truncate" style="font-size:12px;margin-top:4px">{{(element.labelTop ? element.title : '&nbsp;')}}</div>
        <v-slider :label="(element.labelTop ? '' : element.title)" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact"
            @change="saveValue(element)"/>
    </div>

    <!-- List -->

    <template v-if="element.type =='List'">
        <v-combobox :id="element.key" v-if="element.allowCustomText" clearable :items="splitOptions(element)" :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
            @change="saveValue(element)"/>
        <v-autocomplete :id="element.key" v-else clearable :items="splitOptions(element)" :label="element.title" v-model="element.value" :hide-details="!element.showHint" :single-line="element.compact" :class="{'element-compact':element.compact}"
            @change="saveValue(element)"/>
    </template>

    <!-- Options -->
    <template v-if="element.type=='Options'">
        <div v-if="!element.compact" class="grey--text text--darken-2 truncate" style="font-size:12px;margin-top:0px;margin-bottom:-15px">{{element.title}}</div>
        <v-radio-group  v-model="element.value" :mandatory="false" :hide-details="!element.showHint" @change="saveValue(element)">
        <v-radio v-for="option in splitOptions(element)" :label="option" :value="option" :key="option" color="primary"></v-radio>
        </v-radio-group>
    </template>

    <!-- Checkbox List -->
    <template v-if="element.type=='Checkbox List'">
        <div v-if="!element.compact" class="grey--text text--darken-2 truncate" style="font-size:12px;margin-top:0px;margin-bottom:0px">{{element.title}}</div>
        <v-checkbox v-model="checkboxListValue" v-for="option in splitOptions(element)" @change="saveValue(element)" :label="option" :value="option" :key="option" color="primary" class="checkbox-list"  />
    </template>

    <!-- Heading -->
    <div v-if="element.type =='Heading'" class="element-heading">
        {{element.title}}
    </div>

    <template v-if="element.type =='Switch'">
        <!-- <div v-if="!element.compact" class="grey--text text--darken-2 truncate" style="font-size:12px;margin-top:4px">{{(element.labelTop ? element.title : '&nbsp;')}}</div> -->
        <v-switch v-model="element.value" :label="(element.labelTop ? '' : element.title)" :hide-details="!element.showHint" color="primary"
            @change="saveValue(element)"/>
    </template>

    <!-- Checkbox -->

    <template v-if="element.type =='Checkbox'">
        <!-- <div v-if="!element.compact" style="height:17px"></div> -->
        <v-checkbox :label="element.title" v-model="element.value" color="primary" :hide-details="!element.showHint"
            @change="saveValue(element)"/>
    </template>

    <!-- Date and Time -->

    <template v-if="element.type =='DateTime'">
        <DateTime v-model="element.value" :label="element.title" @change="saveValue(element)" />
    </template>

    <!-- Date -->

    <div v-if="element.type == 'Date'" style="display:flex">
        <div style="flex-grow:1">
            <DateBox :ref="'datebox' + element.key" v-model="element.value" :label="element.title"
            :hide-details="hideHint(element)" :single-line="element.compact"
            :disabled="element.locked" class="field-width"
            :short="element.short"
            :baseDate="getValueFromName(element.relativeTo)"
            @change="saveValue(element)"/>
        </div>
        <div style="margin-top:12px;">
        <v-menu
            left
            v-model="dateMenuVisible"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
            >
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon small color="grey lighten-4"><v-icon color="grey">arrow_drop_down_circle</v-icon></v-btn>
            </template>
            <v-card>
                <div class="mini-menu-bar">{{element.title}}</div>
                <v-date-picker style="margin:0px" class="elevation-0" v-model="element.value" @change="datePickerChanged" no-title scrollable @dblclick="dateMenuVisible = false"/>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn :disabled="!element.value" text @click="makeTaskFromDate">Make Task</v-btn>
                <v-btn color="primary" text @click="dateMenuVisible = false">Close</v-btn>
                </v-card-actions>
            </v-card>
            </v-menu>
        </div>

    </div>

    <CurrencyBox v-if="element.type == 'Currency'" v-model="element.value" :label="element.title"
        :hide-details="hideHint(element)" :single-line="element.compact"
        :disabled="element.locked" class="field-width"
        @change="saveValue(element)" />

    <StatusBox v-if="element.type == 'Status'" v-model="element.value" :options="element.options" @input="saveValue(element)" />

    <!-- Button -->

    <template v-if="element.type=='Button'">
        <v-btn @click.exact.stop.prevent="$emit('button', element)" :color="(element.primary ? 'primary' : 'grey lighten-2')" style="margin-top:13px;margin-left:-8px;margin-right:-6px" :icon="Boolean(element.buttonIcon)">
            <v-icon v-if="element.buttonIcon" >{{element.buttonIcon}}</v-icon>
            <template v-if="!element.buttonIcon">{{element.title}}</template>
        </v-btn>
    </template>

    <!-- User Chooser -->

    <template v-if="element.type=='User Chooser'">
        <UserChooser style="margin-top:18px" v-model="userChooserUser" :role="element.role" :label="element.title" />
    </template>

    <!-- Email -->

    <template v-if="element.type=='Email'" >
        <ElementButton :element="element" icon="email" @click="$emit('action', 'email', element)"></ElementButton>
    </template>

    <!-- SMS -->

    <template v-if="element.type=='SMS'" >
        <v-menu v-if="element.complete" offset-y>
            <template v-slot:activator="{ on }">
            <ElementButton v-on="on" :element="element" icon="chat"></ElementButton>
            </template>
            <v-list>
                <v-list-item @click="$emit('action', 'sms', element)">
                    <v-list-item-title>Send Another</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <ElementButton v-else :element="element" icon="sms" @click="$emit('action', 'sms', element)"></ElementButton>
    </template>

    <!-- Contact Selector -->

    <template v-if="element.type=='Contact Selector'" >

        <div v-for="contactElement in contactElementsForRole(element.role)" :key="contactElement.key">
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <ElementButton :complete="true" :text="fullName(contactElement.contact) + ' (' + contactElement.role + ')'" :element="element" icon="account_circle"/>
                    </div>
                </template>
                <v-list>
                    <v-list-item @click="$emit('action', 'contact-view', contactElement)">
                        <v-list-item-title>View</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('action', 'contact', element)">
                        <v-list-item-title>Add another {{contactElement.role}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('action', 'contact-remove', contactElement)">
                        <v-list-item-title>Remove {{contactElement.role}}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <ElementButton v-if="!contactElementsForRole(element.role).length" :element="element" :text="element.title" icon="account_circle" @click="$emit('action', 'contact', element)"></ElementButton>
    </template>

    <!-- File DEPRECATED -->

    <template v-if="element.type=='File'">
        <div class="element-button">File: {{element.name}}</div>
    </template>

    <!-- File Upload -->

    <template v-if="element.type=='File Upload'">
        <div v-if="!element.compact" style="height:10px;"></div>
        <div style="display:flex;margin-left:0px;">
            <UploadElement :element="element" @menu="uploadElementMenu" style="align-self:top"/>
            <div style="color:#666;font-size:16px;padding:3px;align-self:center">{{element.title}}</div>
        </div>
    </template>

    <!-- Loan Diagram -->

    <!-- <template v-if="element.type=='Loan Diagram'">
        if(element.version && element.version == 2)
        <LoanDiagram :diagram="element.diagram" :passBack="{element:element}" @save="saveLoanDiagram"/>
    </template>       -->

    <!-- Outstandings Diagram -->

    <template v-if="element.type=='Widget' && element.widget == 'Outstandings Diagram'">
        <OutstandingsDiagram @click="void x"/>
    </template>

    <!-- Scheduler -->
    <template v-if="element.type=='Scheduler'">
        <ElementButton xxxv-on="on" :element="element" :text="(element.complete ? 'Scheduled: ' : 'Schedule ') + element.title" icon="today" @click="showTaskDialog(element)"></ElementButton>
    </template>

    <!-- Exporter -->
    <template v-if="element.type=='Exporter'">
        <ElementButton xxxv-on="on" :element="element" text="Export to CRM" icon="mdi-database-export" @click="exportHistory(element)"></ElementButton>
    </template>

    <!-- Charge -->
    <template v-if="element.type=='Charge'">
        <ElementButton xxxv-on="on" :element="element" :text="(element.value ? element.value : element.title)" icon="monetization_on" @click="showChargeDialog(element)"></ElementButton>
        <!-- <DialogBox :charge="chargeDialog.initialValues" :settings="chargeDialog.settings" @save="saveCharge(chargeDialog.page)">
            <ElementControl class="pa-2" :element="chargeDialog.page" ref="chargePage" />
        </DialogBox> -->
        <ChargeDialog @saved="chargeSaved" v-if="chargeDialogData.settings.visible" :settings="chargeDialogData.settings" :charge="chargeDialogData.charge" />
    </template>

    <!-- Lookup -->
    <template v-if="element.type=='Lookup'">
        <v-text-field v-if="!element.help" :label="element.title" v-model="element.value" :hint="merge(element.lookup)" @change="saveValue(element)"/>
        <div v-else style="font-size:16px" :style="{'padding-top': (element.compact ? '2px' : '21px')}">
            <a :class="{'grey--text':!element.value}" href="" @click.exact.stop.prevent="$emit('action', 'display-lookup', element)">{{element.title}}</a>
        </div>
    </template>

    <!-- Html -->
    <template v-if="element.type=='Html'">
        <div v-html="merge(element.value)">

        </div>

    </template>

    <!-- Loan Attributes -->
    <template v-if="element.type=='LoanAttributes'">
        <div class="element-label">
            {{element.title}}
        </div>

        <div>
            {{loanAttributes()}}
        </div>


    </template>

    <!-- Jump -->
    <template v-if="element.type=='Jump'">

        <ElementButton :complete="isTargetComplete(element)" :element="element" icon="gps_fixed" @click="jumpFromElement(element)"></ElementButton>

    </template>

    <!-- Outstanding -->
    <template v-if="element.type=='Outstanding'">
        <div style="display:flex">
            <div style="flex-grow:1" class="text-selectable">
                {{element.text}}

                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                    <div v-on="on" style="display:inline-block;cursor:pointer">
                        <flag :error="element.status && element.status.indexOf('Waiting') > -1"
                        :success = "element.status && element.status.indexOf('Sent') > -1"
                        :purple = "element.status == 'Settlement Condition'"
                        :orange = "element.status == 'Waiting for Broker'"
                        :darkred = "element.status == 'Waiting for Processor'"
                        >{{element.status}}</flag>
                    </div>

                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(option, index) in statusOptions"
                            :key="index"
                            @click="updateElementProperty(element, 'status', option)">

                            <v-list-item-title>{{ option }}</v-list-item-title>
                        </v-list-item>
                        <v-divider/>
                        <v-list-item @click="bulkChangeOutstandings('Waiting', 'Ready to Send')">
                            <v-list-item-title>All Ready</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="bulkChangeOutstandings('Ready to Send', 'Sent')">
                            <v-list-item-title>All Sent</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                    <template v-for="linkedFileKey in element.linkedFileKeys">
                    <a class="transparent" :href="fileFromId(linkedFileKey).value" target="_blank" :key="linkedFileKey">
                        <flag class="clickable" white>{{fileFromId(linkedFileKey).fileName}}</flag>
                    </a>
                    </template>

                <div class="grey--text">
                {{element.response}}
                </div>

            </div>
            <div>
                <UploadElement :element="element" style="align-self:top"/>
            </div>
        </div>


    </template>

    <!-- Checklist -->
    <template v-if="element.type=='Checklist'">

        <div style="display:flex;padding-left:4px;" @click="toggleChecklist(element)">
            <div >
                <v-progress-circular
                :value="element.percent || 0"
                color="blue" :width="6" :size="30" :rotate="-90"
                ></v-progress-circular>
            </div>
            <div style="flex-grow:1;font-size:16px;color:#555;padding-left:10px;padding-top:5px;">
                <b>{{element.title}}</b>
                <v-icon v-if="element.collapsed" style="float:right;margin-top:0px">keyboard_arrow_down</v-icon>
            </div>
        </div>
        <v-expand-transition>
        <checklist style="margin-top:7px" v-if="!element.collapsed" :list="element.checklist" :passBack="{element:element}" @save="saveChecklist" />
        </v-expand-transition>

    </template>

    <!-- Widget -->
    <template v-if="element.type=='Widget'">
        <ImportItems v-if="element.widget == 'Import Outstandings'" :compact="element.compact" @importItems="importItems" @saveState="saveState" />
        <ElementSummary v-if="element.widget == 'Element Summary'"/>
        <template v-if="element.widget == 'Loan Diagram'">
            <HomeLoan ref="hld" v-if="element.version == '2'" :homeLoan="element.diagram2" :passBack="{element:element}" @save="saveLoanDiagram2" @change="loanDiagramChanged" />
            <LoanDiagram v-else :diagram="element.diagram" :passBack="{element:element}" @save="saveLoanDiagram"/>
        </template>
        <TransactionSummary v-if="element.widget == 'Transaction Summary'" @jump="jumpToElement" @save="saveElement"/>
        <ComingUp v-if="element.widget == 'Coming Up'" :element="element" @jump="jumpToElement" @save="saveElement"/>

    </template>

    <!-- Dialogs   -->
    <TaskDialog :task="taskDialog.model" :settings="taskDialog.settings" @save="saveTask" />
    <ExporterDialog v-if="element.type == 'Exporter' && exporterDialog.settings.visible" :elements="elements"  :settings="exporterDialog.settings" @save="exportSave"/>


</div>
</template>

<script>
import { format, addDays, parse} from 'date-fns'
import Vue from 'vue'
import DateBox from '../ui-elements/DateBox'
import DateTime from '../ui-elements/DateTime'
import Flag from '../ui-elements/Flag'
import Checklist from '../ui-elements/checklist'
import StatusBox from '../ui-elements/StatusBox'
import CurrencyBox from '../ui-elements/CurrencyBox'
import ImportItems from '../ui-elements/ImportItems'
import ElementSummary from '../ui-elements/ElementSummary'
import ElementButton from '../ui-elements/ElementButton'
import Utilities from '../helpers/Utilities'
import MergeHelpers from '../helpers/MergeHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import ElementHelpers from '../helpers/ElementHelpers'
import LookupData from '../helpers/LookupData'
import UploadFirebase from '../ui-elements/UploadFirebase'
import UploadElement from '../ui-elements/UploadElement'
import LoanDiagram from '../ui-elements/LoanDiagram'
import HomeLoan from '../ui-elements/HomeLoan'
import OutstandingsDiagram from '../ui-elements/OutstandingsDiagram'
import UserChooser from '../ui-elements/UserChooser'
import TransactionSummary from '../ui-elements/TransactionSummary'
import ComingUp from '../ui-elements/ComingUp'
import DialogBox from '../ui-elements/DialogBox'
import TaskDialog from '../ui-elements/TaskDialog'
import DateHelpers from '../helpers/DateHelpers'
import AlertHelpers from '../helpers/AlertHelpers'
import PageLayout from '../screens/PageLayout'
import ElementControl from '../screens/ElementControl'
import DataHelpers from '../helpers/DataHelpers'
import ScreenData from '../screens/ScreenData'
import NumberHelpers from '../helpers/NumberHelpers'
import StringHelpers from '../helpers/StringHelpers'
import ExporterDialog from '../ui-elements/ExporterDialog'
import ChargeDialog from '../ui-elements/ChargeDialog'


export default {
    data() {
        return {
            dateMenuVisible: false,
            taskDialog: {
                settings: {
                    visible: false,
                    title: 'Task Details',
                },
                model: {
                    key: null,
                    title: null,
                    due: null,
                    assigned: {},
                }
            },
            exporterDialog: {
                settings: {
                    visible: false,
                    title: 'Export History',
                },
            },
            chargeDialogData: {
                charge: {
                    date: DateHelpers.todayString(),
                    to: null,
                    description: '',
                    amount: 0,
                    from: null,
                    clients: '',
                },
                settings: {
                    visible: false,
                    title: 'Charge Details',
                },
            },

            chargeDialog: {
                settings: {
                    visible: false,
                    title: 'Charge Details',
                },
                initialValues: {
                    key: null,
                    client: null,
                    recipient: null,
                    amount: null,
                },
                page: {
                            title: 'Charge Details',
                            hideTitle: true,
                            hideIcons: true,
                            flat: true,
                            table: 'billing',
                            type: 'Group',
                            elements: [
                                {
                                    name: 'charge_date',
                                    fieldPos: 'i1',
                                    title: 'Charge Date',
                                    type: 'Date',
                                    control: 'Date',
                                    default: '[today]',
                                    value: null,
                                    required: true,
                                },
                                {
                                    name: 'amount',
                                    fieldPos: 'f1',
                                    title: 'Amount',
                                    type: 'Number',
                                    control: 'Currency',
                                    value: null,
                                    required: true,
                                },
                                {
                                    name: 'note',
                                    fieldPos: 'f2',
                                    title: 'Note',
                                    type: 'Text',
                                    control: 'Text',
                                    value: null,
                                },
                                {
                                    name: 'recipient',
                                    fieldPos: 'i2',
                                    title: 'Processor',
                                    type: 'Contact',
                                    control: 'SelectUser',
                                    value: null,
                                    default: '[user]',
                                    required: true,

                                },
                                {
                                    name: 'payer',
                                    fieldPos: 'i3',
                                    title: 'Broker',
                                    type: 'Contact',
                                    control: 'SelectUser',
                                    value: null,
                                    default:null,
                                    required: true,
                                },
                                {
                                    name: 'clients',
                                    fieldPos: 'i4',
                                    title: 'Clients',
                                    type: 'Hidden',
                                    control: 'Text',
                                    hidden: true,
                                    value: null,
                                },
                            ]
                }
            },

        }
    },

    props: {
        element: Object,
        hideHints: Boolean,
    },

    components: {
        Flag,
        DateBox,
        DateTime,
        CurrencyBox,
        ImportItems,
        ElementSummary,
        ElementButton,
        StatusBox,
        Checklist,
        UploadFirebase,
        UploadElement,
        LoanDiagram,
        HomeLoan,
        UserChooser,
        TransactionSummary,
        ComingUp,
        OutstandingsDiagram,
        TaskDialog,
        DialogBox,
        PageLayout,
        ElementControl,
        ExporterDialog,
        ChargeDialog,
    },

    computed: {
        chargeDialogDisabled() {
            return (this.$refs.chargePage ? !this.$refs.chargePage.valid : true)
        },
        selectedSectionKey() {
            let selectedSection = this.$store.getters.selectedSection
            if(!selectedSection)
                return null
            return selectedSection.key
        },
        selectedTabKey() {
            let selectedTab = this.$store.getters.selectedTab
            if(!selectedTab)
                return null
            return selectedTab.key
        },
        elements() {
            return this.$store.getters.elements
        },
        user() {
            return this.$store.getters.user
        },
        statusOptions() {
            return LookupData.outstandingStatuses()
        },
        transaction() {
            return this.$store.getters.transaction
        },
        userChooserUser: {
            get() {
                let contactElements =  ElementHelpers.contactElementsForRole(this.element.role, this.elements)
                if(contactElements.length == 0)
                    return null
                let contactElement = contactElements[0]
                return {...contactElement.contact, key: contactElement.contactKey}
            },
            set(newVal) {
                if(newVal) {
                    this.chooseUser(newVal)
                    //ContactHelpers.replaceContact(this.transaction.key, newVal, this.element.role, this.elements)
                } else {
                    console.log('to unlink here')
                }

            }
        },
        checkboxListValue: {
            get() {
                if(!this.element.value || !Array.isArray(this.element.value))
                    return []
                else
                    return this.element.value
            },
            set(newVal) {
                this.element.value = newVal
            }
        },
        elements() {
            return this.$store.getters.elements
        },

        outstandingItems() {
            return this.elements.filter(o => o.type == 'Outstanding')
        }



    },

    methods: {

        bulkChangeOutstandings(fromStatus, toStatus) {
            this.outstandingItems.forEach(item => {
                if(item.status.startsWith(fromStatus)) {
                    this.$set(item, 'status', toStatus)
                    this.saveElement(item)
                }
            })
        },

        loanAttributes() {
            return ElementHelpers.loanAttributes(this.element, this.elements)
        },

        exportHistory(element) {
            this.exporterDialog.settings.element = element
            this.exporterDialog.settings.visible = true
        },

        exportSave(settings) {
            let newElement = {...settings.element}
            newElement.complete = true
            this.saveElement(newElement)
        },

        //date element changed via picker rather than datebox
        datePickerChanged() {
            this.saveElement(this.element)
        },

        toggleSectionComplete() {
            let section = {
                key: this.element.key,
                complete: !Boolean(this.element.complete)
            }
            this.saveElement(section)
        },

        showTaskDialog(element) {

            const dateStr = DateHelpers.smartDaysFromNow(element.days).formatBackwards()
            // const dateStr = addDays(new Date(), element.days).formatBackwards()

            this.taskDialog.model.assigned = this.user

            if(element.role) {
                const elements = ElementHelpers.contactElementsForRole(element.role, this.elements)
                if(elements && elements.length) {
                    this.taskDialog.model.assigned = elements[0].contact
                    this.taskDialog.model.assigned.uid = elements[0].contactKey
                } else
                    AlertHelpers.showAlert('Nobody is assigned to role: ' + element.role)
            }

            this.taskDialog.model.due = dateStr
            this.taskDialog.model.title = element.taskText || element.title
            this.taskDialog.settings.visible = true
            this.taskDialog.settings.triggerElement = element
        },

        saveTask(task, settings) {
            task.sectionKey = this.selectedSectionKey
            task.tabKey = this.selectedTabKey

            //added Sept 2020 to fix missing lender bug...
            task.lender = ElementHelpers.getValueFromName('lender')

            this.$store.dispatch('saveTask', task)
            if(settings.triggerElement)
                this.completeElement(settings.triggerElement)
        },

        showChargeDialog(element) {
            let broker = ElementHelpers.singleContactForRole('Broker', this.elements)
            this.chargeDialogData.charge.from = ElementHelpers.singleContactForRole('Processor', this.elements) || this.user
            this.chargeDialogData.charge.date = DateHelpers.todayString()
            this.chargeDialogData.charge.description  = ''
            this.chargeDialogData.charge.clients  = ''
            this.chargeDialogData.charge.amount  = 0

            this.chargeDialogData.charge.to = broker
            this.chargeDialogData.charge.clients = this.transaction.clients
            this.chargeDialogData.settings.visible = true

            return

            this.setDefaultValues(this.chargeDialog.page)
            this.chargeDialog.settings.visible = true
            this.chargeDialog.settings.triggerElement = element
        },

        //TODO: this is temporary to set defaults....

        setDefaultValues(page) {
            page.rowKey = DataHelpers.getKey()
            page.elements.forEach(field => {
                if(field.default == '[today]')
                    field.value = DateHelpers.todayString()
                if(field.default == '[user]')
                    field.value = DataHelpers.getUser()
                if(field.title == 'Amount')
                    field.value = this.element.amount
                if(field.title == 'Broker')
                    field.value = Utilities.getPropertySafely(ElementHelpers.singleContactElementForRole('Broker', this.elements), "contact")
                if(field.title == 'Clients')
                    field.value = this.transaction.clients
            })
        },

        // saveCharge(page) {
        //     console.log("TCL: saveCharge -> page", page)
        //     Vue.set(page, 'scope', 'insight')
        //     ScreenData.savePageValues(page)
        //     let record = ScreenData.pageToRecord(page)
        //     this.element.value = (this.element.value ? this.element.value + ' and ' : '') + 'Charged ' + StringHelpers.formatCurrency(record.amount) + ' on ' + DateHelpers.backwardsToAu(record.charge_date)
        //     this.element.complete = true
        //     this.saveValue(this.element)

        // },

        chargeSaved(summary) {
            this.element.value = (this.element.value ? this.element.value + ' and ' : '') + summary
            this.element.complete = true
            this.saveValue(this.element)
        },

        makeTaskFromDate() {
            this.$emit('action', 'make-task', this.element)
            this.dateMenuVisible = false
        },
        getValueFromName(name) {
            return ElementHelpers.getValueFromName(name)
        },

        jumpFromElement(element) {
            this.$emit('action', 'jump-from', element)
        },

        jumpToElement(element) {
            this.$emit('action', 'jump-to', element)
        },

        // contactElementClick(contactElement) {
        //     console.log('********** contact Element Clicked', contactElement)
        // },

        fullName(contact) {
            return ContactHelpers.fullName(contact)
        },

        clearInput(element) {
            console.log('Clearing input')
            element.value = null
        },

        isTargetComplete(element) {
            let targetElement = this.elements.find(o => o.name == element.target)
            return (targetElement && targetElement.complete)
        },

        uploadElementMenu(action, elements) {
            this.$emit('action', 'email-files', elements)
        },

        chooseUser(user) {
            let payload = {
                user: user,
                role: this.element.role,
            }
            this.$emit('action', 'choose-user', payload)
        },

        updateElementProperty(element, property, option) {
            element[property] = option
            this.saveElement(element)
        },

        importItems(items) {
            let payload = {
                items,
                element: this.element
            }
            this.$emit('action', 'import-outstandings', payload)
        },

        saveState(state) {
            let newElement = Object.assign(this.element, state)
            this.saveElement(newElement)
        },

        saveChecklist(result) {
            Utilities.log('saving checklist...', result)
            let element = result.element
            element.checklist = result.checklist
            element.percent = result.percent
            this.saveElement(element)
        },

        saveLoanDiagram(result) {
            Utilities.log('saving loan diagram...', result)
            let element = result.element
            element.diagram = result.diagram
            element.value = result.value
            this.saveElement(element)
        },

        saveLoanDiagram2(result) {
            this.element.value = result.html
            this.element.summary = result.summary
            this.saveElement(this.element)
        },

        loanDiagramChanged(diagram) {
            this.$set(this.element, 'diagram2', diagram)
        },

        contactElementsForRole(role) {
            return ElementHelpers.contactElementsForRole(role, this.elements)
        },

        merge(path) {
            return MergeHelpers.merge(path, this.elements)
        },

        splitOptions(element) {
            if(element && element.options)
                return element.options.split(',').map(item => item.trim())
            else
                return ['[No Options]']
        },
        hideHint(element) {
            return !element.showHint || this.hideHints
        },
        saveValue(element) {
            this.$nextTick(() => {
                setTimeout(()=>{
                    if(!element.value)
                        element.value = null
                        // this was changed 5/9/18 when value wasn't updating if cleared
                        //  delete element['value']

                    let partialElement = {...element}

                    this.$emit('change', partialElement)

                    if(element.type == 'Lookup') {
                        this.$emit('save-lookup', element.lookup, element.value, element.global)
                    }
                },100)
            })

        },

        saveElement(element) {
            this.$emit('change', element)
        },

        uploadStart(upload, triggerElement) {

            Utilities.log('uploadStart', upload)
            upload.tabKey = 'settings'
            upload.transactionKey = this.transaction.key
            upload.type = 'File'
            upload.title = upload.name
            this.saveElement(upload)
        },

        uploadFinish(upload, triggerElement) {
            Utilities.log('uploadFinish', upload)
            upload.value = upload.url
            upload.triggerElementKey = triggerElement.key
            upload.name = (triggerElement && triggerElement.targetName ? triggerElement.targetName : upload.name)
            this.saveElement(upload)
        },

        uploadStartAll(triggerElement) {
            Utilities.log('uploadStartAll')

            triggerElement.loading = true
            this.saveElement(triggerElement)
        },
        uploadFinishAll(triggerElement) {
            Utilities.log('uploadFinishAll')

            triggerElement.complete = true
            triggerElement.loading = false
            this.saveElement(triggerElement)
        },

        uploadedFiles(element) {
            return this.elements.filter(o => (o.name == element.targetName))
        },
        // scheduleTask(element) {
        //     this.$emit('action', 'make-task', element)
        //     this.completeElement(element)
        // },
        completeElement(element){
            let updates = {
                key: element.key,
                complete: true,
            }
            this.saveElement(updates)
        },

        toggleChecklist(element) {
            element.collapsed = !element.collapsed
            this.saveElement(element)
        },

        fileFromId(fileKey) {
            const element = this.elements.find(o => o.key == fileKey)
            if(!element)
                return {}
            return element
        }
    },

}
</script>

<style scoped>

.section-bar {
    margin-top:16px;text-transform:uppercase;padding:5px 0 5px 10px;
    background-color:#999;color:white;font-weight:600;border-radius:5px;
}

.section-bar.selected {
    background-color: #1c75d2;
}

.section-indicator {
    border-radius:3px;float:left;margin-left:-17px;margin-top:-5px;width:5px;background-color:transparent;height:30px;
    transition: all 1s ease-in-out;
}
.section-indicator.selected {
    background-color:#1c75d2;
}

.section-star {
    color: rgba(250, 248, 248, 0.274);
}

.section-star.complete {
    color:  rgb(253, 239, 44);
    text-shadow: 1px 0px 4px rgba(10, 10, 10, 0.4);
}

.section-star:active {
    text-shadow: 1px 0px 2px rgba(10, 10, 10, 0.8);
}

.section-star:focus {
    outline:0
}


.element-compact {
    margin-top: -10px;
}

.element-button {
    font-size: 16px;
    color: #777;
    padding:8px;
    border: solid 1px transparent;
    border-radius: 4px;
}

.element-button:hover {
    border-color: #ccc;
}

/* .file-container {
    overflow: hidden;
    position: relative;
    width:100%;
}
.file-container [type=file] {
    cursor: inherit;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
} */

.element-heading {
    font-size: 1.3em;
    color: #1c75d2;
    padding-top: 12px;
}

.squares-table td {
    height:10px;width:10px;background-color: #ccc;
}
.squares-table .hilight {
    background-color: #888;
}
.squares-table {
    border-spacing:3px;
}

.mini-menu-bar {
    color:white;
    padding:8px 12px;
    background-color: #1976d2;
    font-weight:600;
    font-size:16px;
}
</style>




// WEBPACK FOOTER //
// ElementItem.vue?355b1fa8